import { useEffect } from "react";
import aboutphoto from "../misc-photos/about.jpg";

const About = () => {    
    useEffect(() => {
        window.scrollTo(0, 0)
    });
    return (
        <div className="container about-container">        
            <div className="about-photo-container-mobile">
                <img src={aboutphoto} alt={"about"} style={{ height: 200, width: 160, borderRadius: '25%' }}/>
            </div>
            <div className="about-resume">
                <h1 className="about-header title-font">About the Teacher</h1>
                <div className="about-text">
                    <ul>
                        <li>
                            <span>Substitute Teacher Island Trees Middle School 2023-present</span>
                        </li>
                        <li>
                            <span>Student Teaching - Michael J. Stokes Elementary School 2024</span>
                        </li>
                        <br />
                        <span><i>Observations:</i></span>
                        <br />
                        <li>
                            <span>Berner Middle School - Massapequa, NY</span>
                        </li>
                        <li>
                            <span>MacArthur High School - Levittown, NY</span>
                        </li>
                        <li>
                            <span>Summit Lane Elementary - Levittown, NY</span>
                        </li>
                        <br />
                        <span><i>Education:</i></span>
                        <br />
                        <li>
                            <span>Bachelor of Fine Arts in Photography and Video- 2018</span>
                        </li>
                        <li>
                            <span>MacArthur High School- 2014</span>
                        </li>
                        <br />
                        <span><i>Workshops:</i></span>
                        <br />
                        <li>
                            <span>Child Abuse Identification October 2022</span>
                        </li>
                        <li>
                            <span>Dignity for All Students Act (DASA) - December 2022</span>
                        </li>
                        <li>
                            <span>Child Abuse Identification (New Program) 2024</span>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="about-photo-container">
                <img src={aboutphoto} alt={"about"} style={{ maxWidth: '100vw',  objectFit: 'contain'}}/>
            </div>
        </div>
    )
};

export default About;